module.exports = __webpack_public_path__ + "static/media/google-ads.91051b39.svg";